export default [
  {
    header: 'Administración',
    resource: 'admin',
    action: 'manage',
  },
  {
    title: 'Catálogos',
    icon: 'ListIcon',
    resource: 'admin',
    action: 'manage',
    children: [
      {
        title: 'Edificios',
        route: 'admin-buildings',
        resource: 'admin',
        action: 'manage',
      },
      {
        title: 'Salones',
        route: 'admin-classrooms',
        resource: 'admin',
        action: 'manage',
      },
      {
        title: 'Facultades',
        route: 'admin-faculties',
        resource: 'admin',
        action: 'manage',
      },
      {
        title: 'Carreras',
        route: 'admin-programs',
        resource: 'admin',
        action: 'manage',
      },
      {
        title: 'Cursos',
        route: 'admin-courses',
        resource: 'admin',
        action: 'manage',
      },
      {
        title: 'Secciones',
        route: 'admin-sections',
        resource: 'admin',
        action: 'manage',
      },
      {
        title: 'Docentes',
        route: 'admin-teachers',
        resource: 'admin',
        action: 'manage',
      },
      {
        title: 'Personas',
        route: 'admin-persons',
        resource: 'admin',
        action: 'manage',
      },
    ],
  },
  {
    title: 'Parámetros',
    route: 'admin-params',
    icon: 'SettingsIcon',
    resource: 'admin',
    action: 'manage',
  },
]
